export default function ContactFooter() {
  return (
    <footer className="w-full bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-14 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row lg:justify-between gap-16 lg:gap-24">
          <div className="lg:w-2/5">
            <p className="font-heading text-white text-4xl md:text-5xl font-bold leading-tight">
              Get in touch
              <br />
              with our team.
            </p>
            <p className="text-foreground-300 text-base leading-relaxed mt-8 max-w-sm">
              Based in Auckland, New Zealand. We welcome inquiries from
              organisations seeking reliable engineering partnership for their
              software initiatives.
            </p>
          </div>

          <div className="lg:w-3/5 grid grid-cols-1 sm:grid-cols-3 gap-12">
            <div>
              <h4 className="text-foreground-400 text-xs font-semibold tracking-widest uppercase mb-4">
                Address
              </h4>
              <address className="not-italic text-white/80 text-sm leading-relaxed">
                73 Empire Road
                <br />
                Auckland, 1023
                <br />
                New Zealand
              </address>
            </div>
            <div>
              <h4 className="text-foreground-400 text-xs font-semibold tracking-widest uppercase mb-4">
                Phone
              </h4>
              <p className="text-white/80 text-sm leading-relaxed">
                + 61 468183907
              </p>
            </div>
            <div>
              <h4 className="text-foreground-400 text-xs font-semibold tracking-widest uppercase mb-4">
                Email
              </h4>
              <p className="text-white/80 text-sm leading-relaxed break-all">
                software@tanengata.com
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/40">
        <div className="max-w-7xl mx-auto px-6 md:px-14 py-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} All rights reserved.
          </p>
          <p className="text-foreground-500 text-xs">
            New Zealand
          </p>
        </div>
      </div>
    </footer>
  );
}